/**
 * Copyright © 2025 Delicious AI, LLC
 *
 */

import { gql } from '@apollo/client'

import { PRODUCT_DASHBOARD_INTERVAL_STAT_FRAGMENT } from '@/graphql'

export const GET_PRODUCT_DASHBOARD_INTERVAL_STATS = gql`
  query IntervalProductsDashboardStats($filters: ProductsDashboardFilter) {
    intervalProductsDashboardStats(filters: $filters) {
      period
      results {
        ...ProductDashboardIntervalStat
      }
    }
  }
  ${PRODUCT_DASHBOARD_INTERVAL_STAT_FRAGMENT}
`
